import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { waLink } from "../config/site";

export const DestinationCard = ({ destination }) => (
  <article
    data-testid="destination-card"
    className="group overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-ocean/5 transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-teal-900/10"
  >
    <div className="relative h-64 overflow-hidden">
      <img
        src={destination.image}
        alt={`${destination.name}, ${destination.country}`}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-ocean/80 via-ocean/10 to-transparent" />
      <div className="absolute bottom-4 left-5">
        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-sand">
          {destination.country}
        </p>
        <h3 className="font-display text-2xl font-bold text-white">{destination.name}</h3>
      </div>
    </div>
    <div className="p-5">
      <p className="text-sm leading-relaxed text-mutedink">{destination.description}</p>
      <div className="mt-5 flex items-center gap-3">
        <a
          href={waLink(`Hi ATO, I would like to enquire about a trip to ${destination.name}.`)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`destination-enquire-${destination.name.toLowerCase()}`}
          className="rounded-full bg-coral px-4 py-2 text-xs font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#B01A23]"
        >
          Enquire Now
        </a>
        <Link
          to="/destinations"
          className="inline-flex items-center gap-1 text-xs font-semibold text-turquoise transition-colors hover:text-emeraldsea"
        >
          Explore Destination <ArrowUpRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </div>
  </article>
);
